import { inventory } from '@api';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';
import { z } from 'zod';

export type ConversationInventory = z.infer<
  typeof inventory.conversationInventory.schema
>;

export type FormattedConversationInventory = ConversationInventory & {
  insightTitles?: Record<string, string>;
  economicCalendarEntityNames?: Record<string, string>;
};

export const getConversationInventory = (conversationId: string) =>
  wretchRequest<ConversationInventory>(
    inventory.conversationInventory.path(conversationId),
    {
      schema: inventory.conversationInventory.schema,
    }
  );
